import styled from 'styled-components';

const StyledCircle = styled.div`
    width: 18px;
    min-width: 18px;
    height: 18px;
    background-color: ${props => props.color};
    margin: 0px;
`;

export { StyledCircle };
